import _toLower from "lodash/toLower"
import _trim from "lodash/trim"
import md5 from "crypto-js/md5"

export const getGravatarImgUrl = (email, size = 80) => {
  const queryEmailHash = md5(_toLower(_trim(email)))
  return `https://www.gravatar.com/avatar/${queryEmailHash}?s=${size}&d=blank`
}
